import { useState } from "react"
import toastWrapper from "../../components/toastWrapper"
import { getMessageFromObject } from "../../services/errors"
import { contractsService } from "../../services/entrantService"
import { useDispatch } from "react-redux"
import { closeDialogAndResetState, setAllDialogStates } from "../../redux/uiSlice"
import { dialogTypes } from "../../constants"

const useContractsActionHandlers = (
    tableRef, handleMenuClose,
    currentContract
) => {

    const dispatch = useDispatch()

    const handleCloseDialog = () => dispatch(closeDialogAndResetState())

    const handleOpenHistoryDialog = () => dispatch(setAllDialogStates({ dialogType: dialogTypes.CONTRACT_HISTORY }))

    const [actionsIsLoading, setActionsIsLoading] = useState(false)

    const actionNamesMap = {
        create_contract: "Создать договор",
        request_contract: "Запросить договор",
        set_wait_for_entrant_signature: "Ожидает подписи абитуриента",
        terminate_contract: "Расторгнуть договор",
        upload_contract_signed_by_entrant: "Загрузить договор, подписаный абитуриентом",
        upload_contract_signed_by_university: "Загрузить договор, подписаный универститетом",
    }

    const actionMessagesMap = {
        create_contract: { success: "Договор создан", error: "Не удалось создать договор", },
        request_contract: { success: "Договор запрошен", error: "Не удалось запросить договор", },
        set_wait_for_entrant_signature: { success: "", error: "", },
        terminate_contract: { success: "Договор расторгнут", error: "Не удалось расторгнуть договор", },
        upload_contract_signed_by_entrant: { success: "Договор загружен", error: "Не удалось загрузить договор" },
        upload_contract_signed_by_university: { success: "Договор загружен", error: "Не удалось загрузить договор" },
    }

    const actionHandlersMap = {
        create_contract: () => handleAction(contractsService.create_contract, actionMessagesMap.create_contract),
        request_contract: () => handleAction(contractsService.request_contract, actionMessagesMap.request_contract),
        set_wait_for_entrant_signature: () => handleAction(contractsService.set_wait_for_entrant_signature, actionMessagesMap.set_wait_for_entrant_signature),
        terminate_contract: () => handleAction(contractsService.terminate_contract, actionMessagesMap.terminate_contract),
        upload_contract_signed_by_entrant: () => dispatch(setAllDialogStates({ dialogType: dialogTypes.UPLOAD_ENTRANT_CONTRACT, dialogData: currentContract })),
        upload_contract_signed_by_entrant_perform: data => handleAction(
            contractsService.upload_contract_signed_by_entrant,
            actionMessagesMap.upload_contract_signed_by_entrant,
            data
        ),
        upload_contract_signed_by_university: () => dispatch(setAllDialogStates({ dialogType: dialogTypes.UPLOAD_UNIVERSITY_CONTRACT, dialogData: currentContract })),
        upload_contract_signed_by_university_perform: data => handleAction(
            contractsService.upload_contract_signed_by_university,
            actionMessagesMap.upload_contract_signed_by_university,
            data
        ),
    }

    const handleAction = (f, messages, payload = null) => {
        setActionsIsLoading(true)
        f(payload ?? currentContract).then(() => {
            toastWrapper(messages.success, "success")
            tableRef.current.onQueryChange()
            handleMenuClose()
            handleCloseDialog()
            setActionsIsLoading(false)
        }).catch(e => {
            console.error(e)
            if (e?.response?.status === 400) {
                toastWrapper(getMessageFromObject(e?.response?.data) ?? messages.error, "error")
            } else {
                toastWrapper(messages.error, "error")
            }
            tableRef.current.onQueryChange()
            handleMenuClose()
            setActionsIsLoading(false)
        })
    }

    return {
        actionHandlersMap, actionNamesMap, actionsIsLoading, handleCloseDialog, handleOpenHistoryDialog
    }
}

export default useContractsActionHandlers